const url = "https://nokibrokes-server.herokuapp.com"

export const SendMail = async (data) => {
    let result;
    await fetch(url + "/send-mail", {
        method: "POST",
        headers: {
            "Content-type": "application/json"
        },
        body: JSON.stringify({ data })
    })
        .then(res => res.json())
        .then(response => result = response)
        .catch(err => console.log(err))
    return result;
}